import GridCollection from '../GridCollection/GridCollection'
import { useDispatch, useSelector } from 'react-redux'
import cls from '../CollectionPage.module.scss'
import {
    authActions,
    getAcceptedMoments,
    getRejectedMoments,
    getWantedMoments,
} from 'features/anonymousAuth'
import { useCallback, useEffect, useRef, useState } from 'react'
import { ButtonProfile } from 'widgets/ButtonProfile/ButtonProfile'
import { CollectionContainer } from '../CollectionContainer/CollectionContainer'
import { navActions } from 'entities/NavMenu'
import { shareFunc } from 'shared/lib/shareFunc/shareFunc'
import { useNavigate, useParams } from 'react-router-dom'
import {
    Text,
    TextAlign,
    TextColor,
    TextSize,
    TextWeight,
} from 'shared/ui/Text/Text'
import { Button } from 'shared/ui/Button'
import { fetchOtherProfileData } from 'features/otherProfileData/model/services/fetchOtherProfileData'
import { Loader } from 'shared/ui/Loader'
import { Popup } from 'shared/ui/Popup/Popup'
import { copyTextToClipboard } from 'shared/lib/copyTextToTextClipboard/copyTextToTextClipboard'
import { Banner } from 'widgets/Banner/Banner'
import { ColorEnum } from 'shared/ui/Button/ui/Button'
import { BackIcon, CopyIcon, ShareIcon } from 'shared/ui/Icon'
import {
    getOtherAcceptedCardData,
    getOtherCreatedCardData,
    getOtherWantedCardDataWithMyPicks,
    getSelectCardsInOtherCollection,
} from 'app/providers/LoadDataProvider/ui/selectors'
import { WantContainer } from '../WantContainer/WantContainer'
import { setCurrentFriend } from 'shared/api/setCurrentFriend'
import React from 'react'
import { PageError } from 'widgets/PageError'
import { ImageWithSkeleton } from 'shared/ui/ImageWithSkeleton'

const OtherProfilePage = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    let { id } = useParams()

    if (/^\d+$/.test(id)) {
        id = +id
    }

    const status = useSelector((state) => state.otherProfileData.status)
    useEffect(() => {
        dispatch(fetchOtherProfileData(id))
    }, [dispatch, id])

    useEffect(() => {
        if (status === 'not-found') {
            navigate('/notfound', { replace: true })
        }
    }, [navigate, status])

    const userId = useSelector((state) => state.otherProfileData.id)
    const name = useSelector((state) => state.otherProfileData.name)
    const avatar = useSelector((state) => state.otherProfileData.avatar)
    const descr = useSelector((state) => state.otherProfileData.descr)
    const nickname = useSelector((state) => state.otherProfileData.nickname)
    const background = useSelector((state) => state.otherProfileData.background)
    const telegram = useSelector((state) => state.otherProfileData.telegram)

    const myFriends = useSelector((state) => state.auth.friends)
    const myAcceptedMoments = useSelector(getAcceptedMoments)
    const myWantedMoments = useSelector(getWantedMoments)
    const myRejectedMoments = useSelector(getRejectedMoments)
    const myAllMoments = myAcceptedMoments.concat(
        myWantedMoments,
        myRejectedMoments
    )

    const parsedCollections = useSelector(getSelectCardsInOtherCollection)

    const [switcher, setSwitcher] = useState(null)
    const [, setFixedHeader] = useState(true)

    const [secondSwitcher, setSecondSwitcher] = useState(null)

    const [visible, setVisible] = useState(false)
    const [popupText, setPopupText] = useState('Ник скопирован')
    const [friendSaving, setFriendSaving] = useState(false)
    const [friendError, setFriendError] = useState('')

    useEffect(() => {
        const secondSwitcherFriend = sessionStorage.getItem(
            'secondSwitcherFriend'
        )

        if (secondSwitcherFriend) {
            setSecondSwitcher(secondSwitcherFriend)
        } else {
            sessionStorage.setItem('secondSwitcherFriend', 'want')
            setSecondSwitcher('want')
        }
    }, [])

    useEffect(() => {
        dispatch(navActions.setVisible(false))
    }, [dispatch])

    const acceptedCardData = useSelector(getOtherAcceptedCardData)
    const createdCardData = useSelector(getOtherCreatedCardData)

    const wantedCardDataWithMyPicks = useSelector(
        getOtherWantedCardDataWithMyPicks
    )

    let header

    if (switcher === 'accepted') {
        header = 'Достигнуто'
    } else if (switcher === 'created') {
        header = 'Создано'
    }

    const counterCreate = createdCardData.length
    const counterAccept = acceptedCardData.length

    const onToggleWant = () => {
        setSecondSwitcher('want')
        sessionStorage.setItem('secondSwitcherFriend', 'want')
    }

    const onToggleCol = () => {
        setSecondSwitcher('collection')
        sessionStorage.setItem('secondSwitcherFriend', 'collection')
    }

    const onSwitchWanted = () => {
        setSwitcher('created')
        setFixedHeader(true)
    }

    const onSwitchAccepted = () => {
        setSwitcher('accepted')
        setFixedHeader(true)
    }

    const onSwitchBack = () => {
        setSwitcher(null)
        setFixedHeader(true)
    }

    const onClose = () => {
        navigate('/friends')
        dispatch(navActions.setVisible(true))
    }

    const addFriend = async () => {
        if (friendSaving) {
            return
        }

        const shouldAdd = !myFriends.includes(userId)
        setFriendError('')
        setFriendSaving(true)
        try {
            await setCurrentFriend(userId, shouldAdd)
            dispatch(
                shouldAdd
                    ? authActions.addFriend(userId)
                    : authActions.deleteFriend(userId)
            )
        } catch (friendUpdateError) {
            console.error(
                'Ошибка при обновлении списка друзей',
                friendUpdateError
            )
            setFriendError(
                'Не удалось обновить список друзей. Попробуй ещё раз.'
            )
        } finally {
            setFriendSaving(false)
        }
    }

    const timeoutWhaleCopyRef = useRef(null) // реф для таймаута говорящего кита
    const onSpeak = useCallback((text = 'Ник скопирован') => {
        // ф-ция говорящего кита
        clearTimeout(timeoutWhaleCopyRef.current)
        timeoutWhaleCopyRef.current = null
        setPopupText(text)
        setVisible(true)
        timeoutWhaleCopyRef.current = setTimeout(() => {
            setVisible(false)
        }, 3000)
    }, [])

    const copyText = (text) => {
        copyTextToClipboard(text)
        onSpeak()
    }

    const shareProfile = async () => {
        const message = await shareFunc()
        if (message) {
            onSpeak(message)
        }
    }

    const bannerRedirect = () => {
        navigate('/')
    }

    if (status === 'error') {
        return <PageError />
    }

    if (status !== 'resolved') {
        return (
            <div
                style={{
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                }}
            >
                <Loader />
            </div>
        )
    }

    return (
        <div className={cls.CollectionPage}>
            <Popup visible={visible} text={popupText} />
            {myAllMoments.length === 0 ? (
                <Banner>
                    <div className={cls.BannerContainer}>
                        <Text
                            className={cls.BannerText}
                            align={TextAlign.LEFT}
                            // size={TextSize.S}
                            // weight={TextWeight.SBOLD}
                        >
                            Твои мечты уже в MineCards! Найдем их?
                        </Text>
                        <Button
                            color={ColorEnum.BLUE}
                            className={cls.BannerButton}
                            text={'ГОУ'}
                            onClick={bannerRedirect}
                        />
                    </div>
                </Banner>
            ) : null}
            {!switcher ? (
                <div className={cls.ProfileContainer}>
                    <Button
                        ariaLabel="Поделиться профилем"
                        className={cls.Settings}
                        onClick={shareProfile}
                    >
                        <ShareIcon className={cls.Share} />
                    </Button>
                    <Button onClick={onClose} className={cls.Back}>
                        <BackIcon />
                    </Button>
                    <ImageWithSkeleton
                        className={cls.background}
                        alt="background"
                        src={background}
                    />
                    <ImageWithSkeleton
                        className={cls.Avatar}
                        alt="avatar"
                        src={avatar}
                    />
                    <Text
                        className={cls.name}
                        size={TextSize.L}
                        weight={TextWeight.BOLD}
                    >
                        {name}
                    </Text>
                    <Text
                        onClick={() =>
                            copyText(nickname ? `@${nickname}` : `@${id}`)
                        }
                        className={cls.nickname}
                        size={TextSize.S}
                        color={TextColor.TERBLACK}
                    >
                        <div className={cls.nicknameContent}>
                            {nickname ? `@${nickname}` : `@${id}`}
                            <CopyIcon className={cls.nicknameCopyIcon} />
                        </div>
                    </Text>
                    <Text className={cls.description} weight={TextWeight.REG}>
                        {descr}
                    </Text>
                </div>
            ) : null}
            {!switcher ? (
                <ButtonProfile
                    className={cls.ButtonProfile}
                    counterAccept={counterAccept}
                    onSwitchAccepted={onSwitchAccepted}
                    counterWant={counterCreate}
                    onSwitchWanted={onSwitchWanted}
                    addFriend={addFriend}
                    friendSaving={friendSaving}
                    myFriends={myFriends}
                    userId={userId}
                    readonly={true}
                    secondSwitcher={secondSwitcher}
                    onToggleWant={onToggleWant}
                    onToggleCol={onToggleCol}
                    telegram={telegram}
                />
            ) : null}
            {!switcher && friendError ? (
                <Text
                    className={cls.friendError}
                    color={TextColor.RED}
                    size={TextSize.XS}
                >
                    {friendError}
                </Text>
            ) : null}
            {switcher === 'created' ? (
                <GridCollection
                    collection={createdCardData}
                    switcher={switcher}
                    header={header}
                    counterAccept={counterAccept}
                    counterWant={counterCreate}
                    onSwitchBack={onSwitchBack}
                    readonly={true}
                />
            ) : null}
            {switcher === 'accepted' ? (
                <GridCollection
                    collection={acceptedCardData}
                    switcher={switcher}
                    header={header}
                    counterAccept={counterAccept}
                    counterWant={counterCreate}
                    onSwitchBack={onSwitchBack}
                    readonly={true}
                />
            ) : null}
            {!switcher ? (
                <>
                    {secondSwitcher === 'collection' ? (
                        <CollectionContainer
                            margin={myAllMoments.length === 0 ? true : false}
                            collections={parsedCollections}
                            readonly={true}
                        />
                    ) : (
                        <WantContainer
                            myAllMoments={myAllMoments}
                            readonly={true}
                            wantedCardData={wantedCardDataWithMyPicks}
                        />
                    )}
                </>
            ) : null}
        </div>
    )
}

export default OtherProfilePage
